'use client';

import { Details } from '@velocity-exchange/icons';
import React from 'react';
import useVelocityClientIsReady from 'src/hooks/useVelocityClientIsReady';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import { UIMarket } from '@velocity-exchange/common';
import { MARKET_STATS_BAR_CELL_LABEL_NO_UNDERLINE_CLASSNAME } from 'src/components/MarketStatsBar/consts';
import TextButton from 'src/components/primitives/TextButton/TextButton';

const ViewDetailsForMarketButtonInner = ({ market }: { market: UIMarket }) => {
	const velocityClientIsReady = useVelocityClientIsReady();
	const setDrawerStore = useDrawersStore((s) => s.set);

	const showMarketDetailsPanel = () => {
		if (velocityClientIsReady) {
			setDrawerStore((s) => {
				s.marketDetails.uiMarket = market;
				s.marketDetails.goToPnl = false;
				s.marketDetails.show = true;
			});
		}
	};

	return (
		<div className="flex flex-col items-start gap-y-xs px-sm select-none">
			<span className={MARKET_STATS_BAR_CELL_LABEL_NO_UNDERLINE_CLASSNAME}>
				Market Details
			</span>

			<TextButton rightIcon={Details} onClick={showMarketDetailsPanel}>
				View
			</TextButton>
		</div>
	);
};

export const ViewDetailsForMarketButton = React.memo(
	ViewDetailsForMarketButtonInner
);
